import { CommApiInstance} from "Utils/CommApiInstance";


const LoginIdDupChkApi = async (
    loginId:string,
    ReCaptchaToken:string
) => {
    return await CommApiInstance.post(`comm/login_id/dup_chk`,{
        apiBody: {
            chkVal:loginId,
            cptchTkn:ReCaptchaToken
        }
    }).then((Resp) => Resp.data);
}
export default LoginIdDupChkApi;